<template>
  <div class="contacts-page row">
    <div class="left-wrap bg-custom" :class="wrapClas">
      <contacts-header
        :search-query="searchQuery"
        :segments-id="segmentsId"
        :on-search-submit="onSearchSubmit"
        this-selected-contact-id=""
        :on-input-search="onInputSearch"
        :on-toggle-create="onToggleCreate"
        :on-toggle-import="onToggleImport"
        :on-toggle-filter="onToggleFilters"
        :header-title="pageTitle"
        @on-toggle-save-filter="onToggleSaveFilters"
        @on-toggle-delete-filter="onToggleDeleteFilters"
      />
        <div class="d-flex justify-content-end mx-4 my-5">
            <svg  @click="onToggleFilters" class="mr-3 cursor-pointer" width="36" height="36" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 16C0 8.45753 0 4.68629 2.34315 2.34315C4.68629 0 8.45753 0 16 0H28C35.5425 0 39.3137 0 41.6569 2.34315C44 4.68629 44 8.45753 44 16V28C44 35.5425 44 39.3137 41.6569 41.6569C39.3137 44 35.5425 44 28 44H16C8.45753 44 4.68629 44 2.34315 41.6569C0 39.3137 0 35.5425 0 28V16Z" fill="#EDECF6"/>
                <path d="M13.3499 12H22.2499C22.9899 12 23.5999 12.61 23.5999 13.35V14.83C23.5999 15.37 23.2599 16.04 22.9299 16.38L20.0299 18.94C19.6299 19.28 19.3599 19.95 19.3599 20.49V23.39C19.3599 23.79 19.0899 24.33 18.7499 24.54L17.8099 25.15C16.9299 25.69 15.7198 25.08 15.7198 24V20.43C15.7198 19.96 15.4499 19.35 15.1799 19.01L12.6199 16.31C12.2799 15.97 12.0099 15.37 12.0099 14.96V13.41C11.9999 12.61 12.6099 12 13.3499 12Z" stroke="#483A9D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 22.0002V25.0002C12 30.0002 14 32.0002 19 32.0002H25C30 32.0002 32 30.0002 32 25.0002V19.0002C32 15.8802 31.22 13.9202 29.41 12.9002C28.9 12.6102 27.88 12.3902 26.95 12.2402" stroke="#483A9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 23H28" stroke="#483A9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 27H28" stroke="#483A9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

<!--            <svg @click="onToggleImport" class="mr-3 cursor-pointer" width="36" height="36" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 16C0 8.45753 0 4.68629 2.34315 2.34315C4.68629 0 8.45753 0 16 0H28C35.5425 0 39.3137 0 41.6569 2.34315C44 4.68629 44 8.45753 44 16V28C44 35.5425 44 39.3137 41.6569 41.6569C39.3137 44 35.5425 44 28 44H16C8.45753 44 4.68629 44 2.34315 41.6569C0 39.3137 0 35.5425 0 28V16Z" fill="#EDECF6"/>
                <path d="M20 16H24C26 16 26 15 26 14C26 12 25 12 24 12H20C19 12 18 12 18 14C18 16 19 16 20 16Z" stroke="#483A9D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M24 32H19C14 32 13 30 13 26V20C13 15.44 14.67 14.2 18 14.02" stroke="#483A9D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M26 14.02C29.33 14.2 31 15.43 31 20V25" stroke="#483A9D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M31 29V32H28" stroke="#483A9D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M25 26L30.96 31.96" stroke="#483A9D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>-->

            <button @click="onToggleCreate"  class="btn btn-primary" style="height: 35px">
                <svg style="margin-top: -3px" width="100" height="24" viewBox="0 0 130 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.5601 19V14" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M18 16.5H13" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.8098 3.41992C19.1498 3.53992 20.8398 4.76992 20.9398 9.46992L21.0698 15.6399C21.1498 19.7599 20.1998 21.8299 15.1998 21.9399L9.19983 22.0599C4.19983 22.1599 3.15983 20.1199 3.07983 16.0099L2.93983 9.82992C2.83983 5.12992 4.48983 3.82992 7.80983 3.57992L15.8098 3.41992Z" stroke="white" stroke-width="1.2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.37012 6.87988H11.6201H6.37012Z" fill="white"/>
                    <path d="M6.37012 6.87988H11.6201" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6.37012 10.8799H11.6201" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M36.2301 17.5H34.7528L39.0256 5.86364H40.4801L44.7528 17.5H43.2756L39.7983 7.70455H39.7074L36.2301 17.5ZM36.7756 12.9545H42.7301V14.2045H36.7756V12.9545ZM49.679 17.6818C48.9517 17.6818 48.3097 17.4981 47.7528 17.1307C47.196 16.7595 46.7604 16.2367 46.446 15.5625C46.1316 14.8845 45.9744 14.0833 45.9744 13.1591C45.9744 12.2424 46.1316 11.447 46.446 10.7727C46.7604 10.0985 47.1979 9.57765 47.7585 9.21023C48.3191 8.8428 48.9669 8.65909 49.7017 8.65909C50.2699 8.65909 50.7188 8.75379 51.0483 8.94318C51.3816 9.12879 51.6354 9.34091 51.8097 9.57955C51.9877 9.81439 52.1259 10.0076 52.2244 10.1591H52.3381V5.86364H53.679V17.5H52.3835V16.1591H52.2244C52.1259 16.3182 51.9858 16.5189 51.804 16.7614C51.6222 17 51.3627 17.214 51.0256 17.4034C50.6884 17.589 50.2396 17.6818 49.679 17.6818ZM49.8608 16.4773C50.3987 16.4773 50.8532 16.3371 51.2244 16.0568C51.5956 15.7727 51.8778 15.3807 52.071 14.8807C52.2642 14.3769 52.3608 13.7955 52.3608 13.1364C52.3608 12.4848 52.2661 11.9148 52.0767 11.4261C51.8873 10.9337 51.607 10.5511 51.2358 10.2784C50.8646 10.0019 50.4063 9.86364 49.8608 9.86364C49.2926 9.86364 48.8191 10.0095 48.4403 10.3011C48.0653 10.589 47.7831 10.9811 47.5938 11.4773C47.4081 11.9697 47.3153 12.5227 47.3153 13.1364C47.3153 13.7576 47.41 14.322 47.5994 14.8295C47.7926 15.3333 48.0767 15.7348 48.4517 16.0341C48.8305 16.3295 49.3002 16.4773 49.8608 16.4773ZM59.6165 17.6818C58.8892 17.6818 58.2472 17.4981 57.6903 17.1307C57.1335 16.7595 56.6979 16.2367 56.3835 15.5625C56.0691 14.8845 55.9119 14.0833 55.9119 13.1591C55.9119 12.2424 56.0691 11.447 56.3835 10.7727C56.6979 10.0985 57.1354 9.57765 57.696 9.21023C58.2566 8.8428 58.9044 8.65909 59.6392 8.65909C60.2074 8.65909 60.6563 8.75379 60.9858 8.94318C61.3191 9.12879 61.5729 9.34091 61.7472 9.57955C61.9252 9.81439 62.0634 10.0076 62.1619 10.1591H62.2756V5.86364H63.6165V17.5H62.321V16.1591H62.1619C62.0634 16.3182 61.9233 16.5189 61.7415 16.7614C61.5597 17 61.3002 17.214 60.9631 17.4034C60.6259 17.589 60.1771 17.6818 59.6165 17.6818ZM59.7983 16.4773C60.3362 16.4773 60.7907 16.3371 61.1619 16.0568C61.5331 15.7727 61.8153 15.3807 62.0085 14.8807C62.2017 14.3769 62.2983 13.7955 62.2983 13.1364C62.2983 12.4848 62.2036 11.9148 62.0142 11.4261C61.8248 10.9337 61.5445 10.5511 61.1733 10.2784C60.8021 10.0019 60.3438 9.86364 59.7983 9.86364C59.2301 9.86364 58.7566 10.0095 58.3778 10.3011C58.0028 10.589 57.7206 10.9811 57.5312 11.4773C57.3456 11.9697 57.2528 12.5227 57.2528 13.1364C57.2528 13.7576 57.3475 14.322 57.5369 14.8295C57.7301 15.3333 58.0142 15.7348 58.3892 16.0341C58.768 16.3295 59.2377 16.4773 59.7983 16.4773ZM80.304 9.5H78.8949C78.8116 9.0947 78.6657 8.73864 78.4574 8.43182C78.2528 8.125 78.0028 7.86742 77.7074 7.65909C77.4157 7.44697 77.0919 7.28788 76.7358 7.18182C76.3797 7.07576 76.0085 7.02273 75.6222 7.02273C74.9176 7.02273 74.2794 7.20076 73.7074 7.55682C73.1392 7.91288 72.6866 8.4375 72.3494 9.13068C72.0161 9.82386 71.8494 10.6742 71.8494 11.6818C71.8494 12.6894 72.0161 13.5398 72.3494 14.233C72.6866 14.9261 73.1392 15.4508 73.7074 15.8068C74.2794 16.1629 74.9176 16.3409 75.6222 16.3409C76.0085 16.3409 76.3797 16.2879 76.7358 16.1818C77.0919 16.0758 77.4157 15.9186 77.7074 15.7102C78.0028 15.4981 78.2528 15.2386 78.4574 14.9318C78.6657 14.6212 78.8116 14.2652 78.8949 13.8636H80.304C80.1979 14.4583 80.0047 14.9905 79.7244 15.4602C79.4441 15.9299 79.0956 16.3295 78.679 16.6591C78.2623 16.9848 77.7945 17.233 77.2756 17.4034C76.7604 17.5739 76.2093 17.6591 75.6222 17.6591C74.6297 17.6591 73.7472 17.4167 72.9744 16.9318C72.2017 16.447 71.5938 15.7576 71.1506 14.8636C70.7074 13.9697 70.4858 12.9091 70.4858 11.6818C70.4858 10.4545 70.7074 9.39394 71.1506 8.5C71.5938 7.60606 72.2017 6.91667 72.9744 6.43182C73.7472 5.94697 74.6297 5.70455 75.6222 5.70455C76.2093 5.70455 76.7604 5.78977 77.2756 5.96023C77.7945 6.13068 78.2623 6.38068 78.679 6.71023C79.0956 7.03598 79.4441 7.43371 79.7244 7.90341C80.0047 8.36932 80.1979 8.90151 80.304 9.5ZM85.9446 17.6818C85.1567 17.6818 84.4654 17.4943 83.8707 17.1193C83.2798 16.7443 82.8177 16.2197 82.4844 15.5455C82.1548 14.8712 81.9901 14.0833 81.9901 13.1818C81.9901 12.2727 82.1548 11.4792 82.4844 10.8011C82.8177 10.1231 83.2798 9.59659 83.8707 9.22159C84.4654 8.84659 85.1567 8.65909 85.9446 8.65909C86.7325 8.65909 87.4219 8.84659 88.0128 9.22159C88.6075 9.59659 89.0696 10.1231 89.3991 10.8011C89.7325 11.4792 89.8991 12.2727 89.8991 13.1818C89.8991 14.0833 89.7325 14.8712 89.3991 15.5455C89.0696 16.2197 88.6075 16.7443 88.0128 17.1193C87.4219 17.4943 86.7325 17.6818 85.9446 17.6818ZM85.9446 16.4773C86.5431 16.4773 87.0355 16.3239 87.4219 16.017C87.8082 15.7102 88.0942 15.3068 88.2798 14.8068C88.4654 14.3068 88.5582 13.7652 88.5582 13.1818C88.5582 12.5985 88.4654 12.0549 88.2798 11.5511C88.0942 11.0473 87.8082 10.6402 87.4219 10.3295C87.0355 10.0189 86.5431 9.86364 85.9446 9.86364C85.3461 9.86364 84.8537 10.0189 84.4673 10.3295C84.081 10.6402 83.795 11.0473 83.6094 11.5511C83.4238 12.0549 83.331 12.5985 83.331 13.1818C83.331 13.7652 83.4238 14.3068 83.6094 14.8068C83.795 15.3068 84.081 15.7102 84.4673 16.017C84.8537 16.3239 85.3461 16.4773 85.9446 16.4773ZM93.2869 12.25V17.5H91.946V8.77273H93.2415V10.1364H93.3551C93.5597 9.69318 93.8703 9.33712 94.2869 9.06818C94.7036 8.79545 95.2415 8.65909 95.9006 8.65909C96.4915 8.65909 97.0085 8.7803 97.4517 9.02273C97.8949 9.26136 98.2396 9.625 98.4858 10.1136C98.732 10.5985 98.8551 11.2121 98.8551 11.9545V17.5H97.5142V12.0455C97.5142 11.3598 97.3362 10.8258 96.9801 10.4432C96.6241 10.0568 96.1354 9.86364 95.5142 9.86364C95.0862 9.86364 94.7036 9.95644 94.3665 10.142C94.0331 10.3277 93.7699 10.5985 93.5767 10.9545C93.3835 11.3106 93.2869 11.7424 93.2869 12.25ZM105.101 8.77273V9.90909H100.578V8.77273H105.101ZM101.896 6.68182H103.237V15C103.237 15.3788 103.292 15.6629 103.402 15.8523C103.516 16.0379 103.66 16.1629 103.834 16.2273C104.012 16.2879 104.199 16.3182 104.396 16.3182C104.544 16.3182 104.665 16.3106 104.76 16.2955C104.855 16.2765 104.93 16.2614 104.987 16.25L105.26 17.4545C105.169 17.4886 105.042 17.5227 104.879 17.5568C104.716 17.5947 104.51 17.6136 104.26 17.6136C103.881 17.6136 103.51 17.5322 103.146 17.3693C102.786 17.2064 102.487 16.9583 102.249 16.625C102.014 16.2917 101.896 15.8712 101.896 15.3636V6.68182ZM109.686 17.7045C109.133 17.7045 108.631 17.6004 108.18 17.392C107.73 17.1799 107.372 16.875 107.107 16.4773C106.841 16.0758 106.709 15.5909 106.709 15.0227C106.709 14.5227 106.807 14.1174 107.004 13.8068C107.201 13.4924 107.464 13.2462 107.794 13.0682C108.124 12.8902 108.487 12.7576 108.885 12.6705C109.286 12.5795 109.69 12.5076 110.095 12.4545C110.625 12.3864 111.055 12.3352 111.385 12.3011C111.718 12.2633 111.961 12.2008 112.112 12.1136C112.268 12.0265 112.345 11.875 112.345 11.6591V11.6136C112.345 11.053 112.192 10.6174 111.885 10.3068C111.582 9.99621 111.122 9.84091 110.504 9.84091C109.864 9.84091 109.362 9.98106 108.999 10.2614C108.635 10.5417 108.379 10.8409 108.232 11.1591L106.959 10.7045C107.186 10.1742 107.489 9.76136 107.868 9.46591C108.25 9.16667 108.667 8.95833 109.118 8.84091C109.572 8.7197 110.019 8.65909 110.459 8.65909C110.739 8.65909 111.061 8.69318 111.425 8.76136C111.792 8.82576 112.146 8.96023 112.487 9.16477C112.832 9.36932 113.118 9.67803 113.345 10.0909C113.572 10.5038 113.686 11.0568 113.686 11.75V17.5H112.345V16.3182H112.277C112.186 16.5076 112.035 16.7102 111.822 16.9261C111.61 17.142 111.328 17.3258 110.976 17.4773C110.624 17.6288 110.194 17.7045 109.686 17.7045ZM109.891 16.5C110.421 16.5 110.868 16.3958 111.232 16.1875C111.599 15.9792 111.875 15.7102 112.061 15.3807C112.25 15.0511 112.345 14.7045 112.345 14.3409V13.1136C112.288 13.1818 112.163 13.2443 111.97 13.3011C111.781 13.3542 111.561 13.4015 111.311 13.4432C111.065 13.4811 110.824 13.5152 110.589 13.5455C110.358 13.572 110.171 13.5947 110.027 13.6136C109.679 13.6591 109.353 13.733 109.05 13.8352C108.75 13.9337 108.508 14.0833 108.322 14.2841C108.141 14.4811 108.05 14.75 108.05 15.0909C108.05 15.5568 108.222 15.9091 108.567 16.1477C108.915 16.3826 109.357 16.5 109.891 16.5ZM119.679 17.6818C118.861 17.6818 118.156 17.4886 117.565 17.1023C116.974 16.7159 116.52 16.1837 116.202 15.5057C115.884 14.8277 115.724 14.053 115.724 13.1818C115.724 12.2955 115.887 11.5133 116.213 10.8352C116.543 10.1534 117.001 9.62121 117.588 9.23864C118.179 8.85227 118.868 8.65909 119.656 8.65909C120.27 8.65909 120.823 8.77273 121.315 9C121.808 9.22727 122.211 9.54545 122.526 9.95455C122.84 10.3636 123.035 10.8409 123.111 11.3864H121.77C121.668 10.9886 121.44 10.6364 121.088 10.3295C120.74 10.0189 120.27 9.86364 119.679 9.86364C119.156 9.86364 118.698 10 118.304 10.2727C117.914 10.5417 117.609 10.9223 117.389 11.4148C117.173 11.9034 117.065 12.4773 117.065 13.1364C117.065 13.8106 117.171 14.3977 117.384 14.8977C117.599 15.3977 117.902 15.786 118.293 16.0625C118.687 16.339 119.149 16.4773 119.679 16.4773C120.027 16.4773 120.344 16.4167 120.628 16.2955C120.912 16.1742 121.152 16 121.349 15.7727C121.546 15.5455 121.687 15.2727 121.77 14.9545H123.111C123.035 15.4697 122.848 15.9337 122.548 16.3466C122.253 16.7557 121.861 17.0814 121.372 17.3239C120.887 17.5625 120.323 17.6818 119.679 17.6818ZM128.866 8.77273V9.90909H124.344V8.77273H128.866ZM125.662 6.68182H127.003V15C127.003 15.3788 127.058 15.6629 127.168 15.8523C127.281 16.0379 127.425 16.1629 127.599 16.2273C127.777 16.2879 127.965 16.3182 128.162 16.3182C128.31 16.3182 128.431 16.3106 128.526 16.2955C128.62 16.2765 128.696 16.2614 128.753 16.25L129.026 17.4545C128.935 17.4886 128.808 17.5227 128.645 17.5568C128.482 17.5947 128.276 17.6136 128.026 17.6136C127.647 17.6136 127.276 17.5322 126.912 17.3693C126.552 17.2064 126.253 16.9583 126.014 16.625C125.779 16.2917 125.662 15.8712 125.662 15.3636V6.68182Z" fill="white"/>
                </svg>
            </button>
        </div>
        <contacts-table
         :contacts="currentRecords"
         :show-search-empty-state="showEmptySearchResult"
         :is-loading="uiFlags.isFetching"
         :on-click-contact="openContactInfoPanel"
         :active-contact-id="selectedContactId"
         @on-sort-change="onSortChange"
        />

      <table-footer
        :current-page="Number(meta.currentPage)"
        :total-count="total === 0 ? records.length : total"
        :page-size="size"
        @page-change="onPageUpdate"
      />
    </div>

    <add-custom-views
      v-if="showAddSegmentsModal"
      :custom-views-query="segmentsQuery"
      :filter-type="filterType"
      :open-last-saved-item="openSavedItemInSegment"
      @close="onCloseAddSegmentsModal"
    />
    <delete-custom-views
      v-if="showDeleteSegmentsModal"
      :show-delete-popup.sync="showDeleteSegmentsModal"
      :active-custom-view="activeSegment"
      :custom-views-id="segmentsId"
      :active-filter-type="filterType"
      :open-last-item-after-delete="openLastItemAfterDeleteInSegment"
      @close="onCloseDeleteSegmentsModal"
    />

    <contact-info-panel
      v-if="showContactViewPane"
      :contact="selectedContact"
      :on-close="closeContactInfoPanel"
      @delete="onAddTotal"
    />
    <create-contact :show="showCreateModal" @cancel="onToggleCreate" @create="onAddTotal" />
    <woot-modal :show.sync="showImportModal" :on-close="onToggleImport">
      <import-contacts v-if="showImportModal" :on-close="onToggleImport" />
    </woot-modal>
    <woot-modal
      :show.sync="showFiltersModal"
      :on-close="onToggleFilters"
      size="medium"
    >
      <contacts-advanced-filters
        v-if="showFiltersModal"
        :on-close="onToggleFilters"
        :initial-filter-types="contactFilterItems"
        @applyFilter="onApplyFilter"
        @clearFilters="clearFilters"
      />
    </woot-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ContactsHeader from './Header';
import ContactsTable from './ContactsTable';
import ContactInfoPanel from './ContactInfoPanel';
import CreateContact from 'dashboard/routes/dashboard/conversation/contact/CreateContact';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import ImportContacts from './ImportContacts.vue';
import ContactsAdvancedFilters from './ContactsAdvancedFilters.vue';
import contactFilterItems from '../contactFilterItems';
import filterQueryGenerator from '../../../../helper/filterQueryGenerator';
import AddCustomViews from 'dashboard/routes/dashboard/customviews/AddCustomViews';
import DeleteCustomViews from 'dashboard/routes/dashboard/customviews/DeleteCustomViews';
import Button from "../../../../components/buttons/Button";

const DEFAULT_PAGE = 1;
const FILTER_TYPE_CONTACT = 1;

export default {
  components: {
      Button,
    ContactsHeader,
    ContactsTable,
    TableFooter,
    ContactInfoPanel,
    CreateContact,
    ImportContacts,
    ContactsAdvancedFilters,
    AddCustomViews,
    DeleteCustomViews,
  },
  props: {
    label: { type: String, default: '' },
    segmentsId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      searchQuery: '',
      showCreateModal: false,
      showImportModal: false,
      selectedContactId: '',
      sortConfig: { last_activity_at: 'desc' },
      showFiltersModal: false,
      contactFilterItems: contactFilterItems.map(filter => ({
        ...filter,
        attributeName: this.$t(
          `CONTACTS_FILTER.ATTRIBUTES.${filter.attributeI18nKey}`
        ),
      })),
      segmentsQuery: {},
      filterType: FILTER_TYPE_CONTACT,
      showAddSegmentsModal: false,
      showDeleteSegmentsModal: false,
      size: 5, /* display 5 contacts per page*/
      total: 0,
      appliedFilter: false,  /* check if a filter is applied */
    };
  },
  computed: {
    ...mapGetters({
      records: 'contacts/getContacts',
      uiFlags: 'contacts/getUIFlags',
      meta: 'contacts/getMeta',
      segments: 'customViews/getCustomViews',
      getAppliedContactFilters: 'contacts/getAppliedContactFilters',
    }),
    showEmptySearchResult() {
      const hasEmptyResults = !!this.searchQuery && this.records.length === 0;
      return hasEmptyResults;
    },
    hasAppliedFilters() {
      return this.getAppliedContactFilters.length;
    },
    hasActiveSegments() {
      return this.activeSegment && this.segmentsId !== 0;
    },
    isContactAndLabelDashboard() {
      return (
        this.$route.name === 'contacts_dashboard' ||
        this.$route.name === 'contacts_labels_dashboard'
      );
    },
    pageTitle() {
      if (this.hasActiveSegments) {
        return this.activeSegment.name;
      }
      if (this.label) {
        return `#${this.label}`;
      }
      return this.$t('CONTACTS_PAGE.HEADER');
    },
    selectedContact() {
      if (this.selectedContactId) {
        const contact = this.records.find(
          item => this.selectedContactId === item.id
        );
        return contact;
      }
      return undefined;
    },
    showContactViewPane() {
      return this.selectedContactId !== '';
    },
    wrapClas() {
      return this.showContactViewPane ? 'medium-9' : 'medium-12';
    },
    pageParameter() {
      const selectedPageNumber = Number(this.$route.query?.page);
      return !Number.isNaN(selectedPageNumber) &&
        selectedPageNumber >= DEFAULT_PAGE
        ? selectedPageNumber
        : DEFAULT_PAGE;
    },
    activeSegment() {
      if (this.segmentsId) {
        const [firstValue] = this.segments.filter(
          view => view.id === Number(this.segmentsId)
        );
        return firstValue;
      }
      return undefined;
    },
    /* update the contacts to be displayed in the current page */
    currentRecords() {
      console.log("records in current", this.records);
      return this.records.slice(
        (Number(this.meta.currentPage) - 1) * this.size,
        (Number(this.meta.currentPage) - 1) * this.size + this.size
      )
    },
  },
  watch: {
    label() {
      this.fetchContacts(DEFAULT_PAGE);
      if (this.hasAppliedFilters) {
        this.clearFilters();
      }
    },
    activeSegment() {
      if (this.hasActiveSegments) {
        const payload = this.activeSegment.query;
        this.fetchSavedFilteredContact(payload, DEFAULT_PAGE);
      }
      if (this.hasAppliedFilters && this.$route.name === 'contacts_dashboard') {
        this.fetchFilteredContacts(DEFAULT_PAGE);
      } else {
        this.fetchContacts(DEFAULT_PAGE);
      }
    },
  },
  mounted() {
    this.fetchContacts(this.pageParameter);
  },
  methods: {
    updatePageParam(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
    },
    getSortAttribute() {
      let sortAttr = Object.keys(this.sortConfig).reduce((acc, sortKey) => {
        const sortOrder = this.sortConfig[sortKey];
        if (sortOrder) {
          const sortOrderSign = sortOrder === 'asc' ? '' : '-';
          return `${sortOrderSign}${sortKey}`;
        }
        return acc;
      }, '');
      if (!sortAttr) {
        this.sortConfig = { last_activity_at: 'desc' };
        sortAttr = '-last_activity_at';
      }
      return sortAttr;
    },
    fetchContacts(page) {
      if (this.isContactAndLabelDashboard) {
        this.updatePageParam(page);
        let value = '';
        if (this.searchQuery.charAt(0) === '+') {
          value = this.searchQuery.substring(1);
        } else {
          value = this.searchQuery;
        }
        const requestParams = {
          page,
          sortAttr: this.getSortAttribute(),
          label: this.label,
        };
        if (!value) {
          this.$store.dispatch('contacts/get', requestParams);
        } else {
          this.$store.dispatch('contacts/search', {
            search: encodeURIComponent(value),
            ...requestParams,
          });
        }
      }
    },
    fetchSavedFilteredContact(payload, page) {
      if (this.hasActiveSegments) {
        this.updatePageParam(page);
        this.$store.dispatch('contacts/filter', {
          queryPayload: payload,
          page,
        });
      }
    },
    fetchFilteredContacts(page) {
      if (this.hasAppliedFilters) {
        const payload = this.segmentsQuery;
        this.updatePageParam(page);
        this.$store.dispatch('contacts/filter', {
          queryPayload: payload,
          page,
        });
      }
    },

    onInputSearch(event) {
      const newQuery = event.target.value;
      const refetchAllContacts = !!this.searchQuery && newQuery === '';
      this.searchQuery = newQuery;
      if (refetchAllContacts) {
        this.fetchContacts(DEFAULT_PAGE);
      }
    },
    onSearchSubmit() {
      this.selectedContactId = '';
      if (this.searchQuery) {
        this.fetchContacts(DEFAULT_PAGE);
      }
    },
    onPageChange(page) {
      this.selectedContactId = '';
      if (this.segmentsId !== 0) {
        const payload = this.activeSegment.query;
        this.fetchSavedFilteredContact(payload, page);
      }
      if (this.hasAppliedFilters) {
        this.fetchFilteredContacts(page);
      } else {
        this.fetchContacts(page);
      }
    },
    openContactInfoPanel(contactId) {
      this.selectedContactId = contactId;
      this.showContactInfoPanelPane = true;
    },
    closeContactInfoPanel() {
      this.selectedContactId = '';
      this.showContactInfoPanelPane = false;
    },
    onToggleCreate() {
      this.showCreateModal = !this.showCreateModal;
    },
    onToggleSaveFilters() {
      this.showAddSegmentsModal = true;
    },
    onCloseAddSegmentsModal() {
      this.showAddSegmentsModal = false;
    },
    onToggleDeleteFilters() {
      this.showDeleteSegmentsModal = true;
    },
    onCloseDeleteSegmentsModal() {
      this.showDeleteSegmentsModal = false;
    },
    onToggleImport() {
      this.showImportModal = !this.showImportModal;
    },
    onSortChange(params) {
      this.sortConfig = params;
      this.fetchContacts(this.meta.currentPage);
    },
    onToggleFilters() {
      this.showFiltersModal = !this.showFiltersModal;
    },
    onApplyFilter(payload) {
      this.closeContactInfoPanel();
      this.segmentsQuery = filterQueryGenerator(payload);
      this.$store.dispatch('contacts/filter', {
        queryPayload: filterQueryGenerator(payload),
      });
      this.appliedFilter = true; /* to update the pagination */
      this.onAddTotal();         /* with records filtered number */
      this.showFiltersModal = false;
    },
    clearFilters() {
      this.$store.dispatch('contacts/clearContactFilters');
      this.fetchContacts(this.pageParameter);
      this.appliedFilter = false; /* to update the pagination */
      this.total = 0; /* with all records number */
    },
    openSavedItemInSegment() {
      const lastItemInSegments = this.segments[this.segments.length - 1];
      const lastItemId = lastItemInSegments.id;
      this.$router.push({
        name: 'contacts_segments_dashboard',
        params: { id: lastItemId },
      });
    },
    openLastItemAfterDeleteInSegment() {
      if (this.segments.length > 0) {
        this.openSavedItemInSegment();
      } else {
        this.$router.push({ name: 'contacts_dashboard' });
        this.fetchContacts(DEFAULT_PAGE);
      }
    },
    /* change the current page by clicking on the page number */
    onPageUpdate(page) {
      this.meta.currentPage = page;
    },
    /* update the number of pages according to the total number of contacts */
    onAddTotal() {
      /* verify if there is an applied filter  */
      if (this.appliedFilter === true) {
        this.total = 0; /* to update page's number with records filtered number */
        this.appliedFilter = false;
      }
      else {
        /* update page's number cause a create or a delete of a contact */
        const prevCount = this.total;
        const contacts = this.$store.getters['contacts/getContacts'];
        this.total = contacts.length;
        /* return to the previous page when the last element of the current page is deleted */
        if (this.total < prevCount && this.total % 5 === 0) {
          this.meta.currentPage = this.meta.currentPage - 1;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts-page {
  width: 100%;
}

.left-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.bg-custom{
  background-color: #F9F9F9 !important;
}
</style>
